/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useEffect } from 'react';
import PropType from 'prop-types';
import PricingCountUp from './pricingCountUp';
import PlanFeatures from './planFeatures';
import { __ } from '../../lib/i18n';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { LIVE } from '../../common/variables';

function BasicPricingCard({
  lang,
  name,
  priceMonth,
  priceYear,
  description,
  billingPeriod,
  firstRender,
  subscribed,
  handleClick,
  disabled
}) {
  function PriceAmount() {
    return (
      <PricingCountUp
        price={billingPeriod === 'month' ? priceMonth : priceYear}
        startFrom={billingPeriod === 'month' ? priceYear : priceMonth}
      />
    );
  }
  function PriceAmountAnimation() {
    switch (billingPeriod) {
      case 'month':
        return priceMonth;
      default:
        return priceYear;
    }
  }

  const clssName = disabled ? "" : "hover:bg-blue-500 hover:text-white active:bg-blue-600";

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <>
      <div
        role="listitem"
        className="bg-yellow-200 shadow rounded-xl mt-3 flex relative z-30 w-full md:w-80"
        // onClick={handleChangeSelectedPlan}
        style={{ minHeight: '350px' }}>
        <div className="w-full p-4 flex flex-col justify-between">
          <p
            className="m-0 text-center text-4xl font-bold text-black">
            YUGE <br /> mobile <br /> APP
          </p>
          <div>
            <p className="leading-10 text-center text-4xl md:mt-0 mt-4 font-bold leading-6 mb-1">
            {lang === 'en' ? '$' : '€'} {firstRender ? <PriceAmountAnimation /> : <PriceAmount />}/<span style={{ fontSize: "1.5rem" }}> {__(lang, billingPeriod === "monthly" ? "MONTH" : "YEAR")}</span>
            </p>
            <p className="text-center mb-4 text-lg font-semibold">
              {`{${__(lang, "EXT_BTW")}}`}
            </p>
              <button
                onClick={handleClick}
                className={`bg-gray-50 bg-opacity-80 w-full text-black border border-gray-200 font-semibold py-2 rounded-full outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 ${clssName}`}
                type="button"
                disabled={disabled}>
                {__(lang, subscribed ? 'SUBSCRIBED' : 'SUBSCRIBE')}
              </button>
          </div>
        </div>
      </div>
    </>
  );
}

function RecommendedPricingCard({
  lang,
  name,
  priceMonth,
  priceYear,
  description,
  billingPeriod,
  firstRender,
  subscribed,
  disabled,
  handleClick
}) {
  function PriceAmount() {
    return (
      <PricingCountUp
        price={billingPeriod === 'month' ? priceMonth : priceYear}
        startFrom={billingPeriod === 'month' ? priceYear : priceMonth}
      />
    );
  }
  function PriceAmountAnimation() {
    switch (billingPeriod) {
      case 'month':
        return priceMonth;
      default:
        return priceYear;
    }
  }

  const clssName = disabled ? "" : "hover:bg-blue-500 hover:text-white active:bg-blue-600";

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      role="listitem"
      className="bg-green-300 shadow rounded-xl mt-3 flex flex-col relative z-30 w-full md:w-80"
      // onClick={handleChangeSelectedPlan}
      style={{ minHeight: '400px' }}>
      <p className="text-lg flex justify-center font-bold mb-2">
        <span className="p-2 px-4 bg-green-100 bg-opacity-80 rounded-b-xl ">{__(lang, "RECOMMENDED")}</span>
      </p>
      <div className="w-full p-4 flex flex-col justify-between">
        <p
          className="m-0 text-center text-primary px-4 text-4xl font-bold"
          style={{ color: '#000' }}>
          {__(lang, name)}
        </p>
        <div>
          <p className="text-base p-3 font-bold">{__(lang, description)}</p>
          <p className="leading-10 text-center md:mt-0 mt-4 font-bold leading-6 text-5xl mb-1">
            {lang === 'en' ? '$' : '€'} {firstRender ? <PriceAmountAnimation /> : <PriceAmount />}/<span style={{ fontSize: "1.5rem" }}> {__(lang, billingPeriod === "monthly" ? "MONTH" : "YEAR")}</span>
          </p>
          <p className="text-center text-lg font-semibold">
            {`{${__(lang, "EXT_BTW")}}`}
          </p>
          <p className="text-center font-semibold text-lg my-4">
            {__(lang, 'FREE_TRIAL_PRICING')}
          </p>
            <button
              onClick={handleClick}
              type="button"
              className={`bg-gray-50 bg-opacity-80 w-full text-black border border-gray-200 font-semibold py-2 rounded-full outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
              disabled={disabled}>
              {__(lang, subscribed ? 'SUBSCRIBED' : 'SUBSCRIBE')}
            </button>
        </div>
      </div>
    </div>
  );
}

function FlexiblePricingCard({
  lang,
  name,
  description,
}) {
  const handleClick = (event) => {
    event.preventDefault();
    window.location = LIVE ? "https://goyuge.com/contact" : "https://dev-web-app-spa.goyuge.com/contact";
  };
  return (
    <div
      role="listitem"
      className="bg-gray-200 shadow rounded-xl mt-3 flex relative z-30 w-full md:w-80"
      // onClick={handleChangeSelectedPlan}
      style={{ minHeight: '350px' }}>
      <div className="w-full p-4 flex flex-col justify-between">
        <p
          className="m-0 text-center text-4xl text-black">
          {__(lang, name)}
        </p>
          <p className="text-base p-3 font-bold">{__(lang, description)}</p>
          <button
            type="button"
            className={`bg-gray-50 bg-opacity-80 w-full text-black border-2 border-gray-400 font-semibold py-2 rounded-full outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
            onClick={handleClick}
          >
            {__(lang, 'GET_QUOTE')}
          </button>
      </div>
    </div>
  );
}

function PricingCard(props) {
  const { features } = props;
  const { app } = useSelector((state) => state);
  const { user } = app;

  const onClickPlan = (index) => {
    props.handleChangeSelectedPlan(index)
  };

  let component = (
    <BasicPricingCard
      handleClick={() => onClickPlan(0)}
      {...props}
    />
  );
  if (props.featured)
    component = (
      <RecommendedPricingCard
        handleClick={() => onClickPlan(1)}
        {...props}
      />
    );
  if (!props.featured && !props.freeTrial)
    component = <FlexiblePricingCard {...props} />;

  return (
    <div className="w-full md:w-auto">
      {component}
      <div className="d-block d-md-none">
        <PlanFeatures lang={props.lang} features={features} />
      </div>
    </div>
  );
}

PricingCard.propTypes = {
  name: PropType.string,
  priceMonth: PropType.number,
  priceYear: PropType.number,
  description: PropType.string,
  featured: PropType.bool,
  billingPeriod: PropType.string,
  firstRender: PropType.bool,
  handleChangeSelectedPlan: PropType.func,
  freeTrial: PropType.bool.isRequired,
  features: PropType.array,
  subscribed: PropType.bool,
};

export default memo(PricingCard);
